import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = ["action", "method"]
const _hoisted_2 = {
  key: 1,
  class: "el-row el-row-root"
}
const _hoisted_3 = { class: "el-col el-col-24" }
const _hoisted_4 = ["innerHTML"]
const _hoisted_5 = ["name", "value"]

import {ref} from 'vue';
import {PaymentSystemFrontendFormParamsInterface} from './PaymentSystemFrontendFormParamsInterface';


const __default__ = {
    name: "CoreUiPaymentForm"
}

export default /*@__PURE__*/_defineComponent({
  ...__default__,
  props: {
    form: {},
    successCallback: { type: Function },
    errorCallback: { type: Function },
    closeCallback: { type: Function }
  },
  setup(__props: any) {

let props = __props;


let formElement = ref<HTMLFormElement>();


function onSubmit(): boolean | void {
    if (!props.form.formAction) {
        if (props.form.loadScript) {
            var script = document.createElement('script');
            script.onload = () => {
                if (props.form.loadScriptCallback) {
                    var callback = function (ignored: any) {
                    };
                    eval(`callback = ${props.form.loadScriptCallback};`);
                    var input: HTMLInputElement = formElement.value.querySelector(`[name=${props.form.sumInputName}]`);
                    callback({
                        onSuccess: props.successCallback,
                        onError: props.errorCallback,
                        closeDialog: props.closeCallback,
                        clientId: props.form.clientId,
                        paymentDescription: props.form.paymentDescription,
                        sum: parseFloat(input.value)
                    });
                }
            };
            script.src = props.form.loadScript;

            document.head.appendChild(script); //or something of the likes
        }
    } else {
        formElement.value.submit();
        return true;
    }
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("form", {
    action: _ctx.form.formAction,
    method: _ctx.form.formMethod,
    target: "_blank",
    onSubmit: _withModifiers(onSubmit, ["prevent"]),
    ref_key: "formElement",
    ref: formElement
  }, [
    (_ctx.form.showInput)
      ? _renderSlot(_ctx.$slots, "default", { key: 0 })
      : _createCommentVNode("", true),
    (_ctx.form.html)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", {
              innerHTML: _ctx.form.html
            }, null, 8, _hoisted_4)
          ])
        ]))
      : _createCommentVNode("", true),
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.form.hiddenInputs, (input, key) => {
      return (_openBlock(), _createElementBlock("input", {
        key: key,
        name: input.name,
        value: input.value,
        type: "hidden"
      }, null, 8, _hoisted_5))
    }), 128))
  ], 40, _hoisted_1))
}
}

})